import * as React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const biblicalNames = [{
  id: 1,
  name: "Aaron",
  origin: "Exodus 4:14",
  letter: "A"
}, {
  id: 2,
  name: "Abel",
  origin: "Genesis 4:2",
  letter: "A"
}, {
  id: 3,
  name: "Abigail",
  origin: "1 Samuel 25:3",
  letter: "A"
}, {
  id: 4,
  name: "Abraham",
  origin: "Genesis 17:5",
  letter: "A"
}, {
  id: 5,
  name: "Adam",
  origin: "Genesis 2:19",
  letter: "A"
}, {
  id: 6,
  name: "Asher",
  origin: "Genesis 30:13",
  letter: "A"
}, {
  id: 7,
  name: "Bartholomew",
  origin: "Matthew 10:3",
  letter: "B"
}, {
  id: 8,
  name: "Bathsheba",
  origin: "2 Samuel 11:3",
  letter: "B"
}, {
  id: 9,
  name: "Benjamin",
  origin: "Genesis 35:18",
  letter: "B"
}, {
  id: 10,
  name: "Boaz",
  origin: "Ruth 2:1",
  letter: "B"
}, {
  id: 11,
  name: "Caleb",
  origin: "Numbers 13:6",
  letter: "C"
}, {
  id: 12,
  name: "Chloe",
  origin: "1 Corinthians 1:11",
  letter: "C"
}, {
  id: 13,
  name: "Cornelius",
  origin: "Acts 10:1",
  letter: "C"
}, {
  id: 14,
  name: "Cyrus",
  origin: "Isaiah 44:28",
  letter: "C"
}, {
  id: 15,
  name: "Daniel",
  origin: "Daniel 1:6",
  letter: "D"
}, {
  id: 16,
  name: "David",
  origin: "1 Samuel 16:13",
  letter: "D"
}, {
  id: 17,
  name: "Deborah",
  origin: "Judges 4:4",
  letter: "D"
}, {
  id: 18,
  name: "Delilah",
  origin: "Judges 16:4",
  letter: "D"
}, {
  id: 19,
  name: "Dinah",
  origin: "Genesis 30:21",
  letter: "D"
}, {
  id: 20,
  name: "Eden",
  origin: "Genesis 2:8",
  letter: "E"
}, {
  id: 21,
  name: "Elijah",
  origin: "1 Kings 17:1",
  letter: "E"
}, {
  id: 22,
  name: "Elizabeth",
  origin: "Luke 1:5",
  letter: "E"
}, {
  id: 23,
  name: "Enoch",
  origin: "Genesis 4:17",
  letter: "E"
}, {
  id: 24,
  name: "Esther",
  origin: "Esther 2:7",
  letter: "E"
}, {
  id: 25,
  name: "Eve",
  origin: "Genesis 3:20",
  letter: "E"
}, {
  id: 26,
  name: "Ezekiel",
  origin: "Ezekiel 1:3",
  letter: "E"
}, {
  id: 27,
  name: "Ezra",
  origin: "Ezra 7:1",
  letter: "E"
}];
const popularNames = [{
  id: 101,
  name: "Noah",
  meaning: "Rest, comfort"
}, {
  id: 102,
  name: "James",
  meaning: "Supplanter"
}, {
  id: 103,
  name: "Mary",
  meaning: "Beloved"
}, {
  id: 104,
  name: "John",
  meaning: "Graced by God"
}, {
  id: 105,
  name: "Sarah",
  meaning: "Princess"
}, {
  id: 106,
  name: "Luke",
  meaning: "Light-giving"
}, {
  id: 107,
  name: "Hannah",
  meaning: "Favor, grace"
}];
export default function BiblicalNameDirectory() {
  const letters = Array.from(new Set(biblicalNames.map(n => n.letter))).sort();
  return <section id="biblical-name-directory" className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-12">
          
          {}
          <div className="lg:col-span-8 xl:col-span-9">
            <div className="mb-12 max-w-3xl">
              <h2 className="text-primary text-3xl font-bold tracking-tight sm:text-4xl mb-4">
                Biblical Name Directory
              </h2>
              <p className="text-foreground text-lg leading-relaxed">
                Explore our comprehensive collection of timeless names with scriptural roots. 
                Each name carries a profound history and meaningful origin, carefully curated 
                for modern parents seeking a name with enduring significance.
              </p>
            </div>

            <div className="space-y-16">
              {letters.map((letter, index) => {
              const namesForLetter = biblicalNames.filter(n => n.letter === letter);
              return <div key={letter} data-index={index} className="scroll-mt-24">
                    <h3 className="text-primary border-border mb-8 border-b pb-4 text-4xl font-bold">
                      {letter}
                    </h3>
                    <ul className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2 lg:gap-x-12">
                      {namesForLetter.map((item, itemIndex) => <li key={item.id} data-index={itemIndex} className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between border-border/50 border-b pb-3 sm:border-none sm:pb-0">
                          <Link to="#" className="text-foreground hover:text-accent text-lg font-semibold transition-colors duration-200">
                            {item.name}
                          </Link>
                          <span className="text-muted-foreground mt-1 text-sm italic sm:mt-0">
                            {item.origin}
                          </span>
                        </li>)}
                    </ul>
                  </div>;
            })}
            </div>
          </div>

          {}
          <div className="lg:col-span-4 xl:col-span-3">
            <div className="sticky top-24">
              <Card className="bg-card border-none shadow-sm rounded-none">
                <CardHeader className="pb-4">
                  <CardTitle className="text-primary text-xl font-bold">
                    Most Popular
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-4">
                    {popularNames.map((name, index) => <li key={name.id} data-index={index} className="group">
                        <Link to="#" className="flex flex-col space-y-1">
                          <span className="text-secondary group-hover:text-accent text-base font-semibold transition-colors duration-200">
                            {name.name}
                          </span>
                          <span className="text-foreground/70 text-sm">
                            {name.meaning}
                          </span>
                        </Link>
                      </li>)}
                  </ul>
                </CardContent>
              </Card>

              <div className="bg-muted mt-8 p-6 rounded-none">
                <h4 className="text-primary mb-3 text-lg font-bold">Need Inspiration?</h4>
                <p className="text-foreground mb-4 text-sm leading-relaxed">
                  Discover the perfect name for your little one by exploring our curated lists of trending and unique names from around the world.
                </p>
                <Link to="/TrendingPage" className="text-secondary hover:text-accent text-sm font-semibold underline underline-offset-4 transition-colors">
                  View Trending Names &rarr;
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}